import React, { useEffect, useState } from 'react'
import { ApiError } from 'services/ApiService'
import SubjectService from 'services/SubjectService'
import styled from 'styled-components'
import { trackPromise } from 'react-promise-tracker'
import LoadingArea from 'components/elements/LoadingArea'
import { Subject } from 'interfaces/Subject'
import Stack from 'components/elements/Stack'
import { CountryCode } from 'interfaces/Country'
import _useTranslation from 'lib/hooks/_useTranslation'
import SubjectCard from 'components/modules/Subjects/SubjectCard'

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 25px;
    row-gap: 25px;
    padding: 35px;
    justify-content: center;
    @media (max-width: 750px) {
        grid-gap: 8px;
        row-gap: 8px;
        grid-template-columns: repeat(auto-fit, minmax(175px, 1fr));
    }
`

const loadingAreas = {
    container: 'chooseSubjects',
}

interface Props {
    country: CountryCode | number
    highlight?: boolean
    onSubjectClick?: (subject: Subject) => void
    showTitleAsSubHeadline?: boolean
    isDarkTheme?: boolean
}

const SubjectsGrid = (props: Props) => {
    const [mainSubjects, setMainSubjects] = useState<Subject[] | null>(null)
    const { t: tCommon } = _useTranslation('common')

    useEffect(() => {
        trackPromise(
            SubjectService.list(props.country)
                .then((subjectList) => {
                    setMainSubjects(subjectList.slice(0, 10))
                })
                .catch((error) => {
                    if (error instanceof ApiError) {
                        error.handleUnknownError(tCommon, 'subject.list')
                    } else {
                        throw error
                    }
                }),
            loadingAreas.container
        )
    }, [props.country, tCommon])

    const onSubjectClick = (subject: Subject) => {
        props.onSubjectClick && props.onSubjectClick(subject)
    }

    return (
        <LoadingArea area={loadingAreas.container}>
            <Stack>
                <Grid>
                    {mainSubjects &&
                        mainSubjects.map((subject) => (
                            <span key={subject.id} onClick={() => onSubjectClick(subject)}>
                                <SubjectCard
                                    subject={subject}
                                    isSelected={props.highlight}
                                    showTitleAsSubHeadline={props.showTitleAsSubHeadline}
                                    isDarkTheme={props.isDarkTheme}
                                />
                            </span>
                        ))}
                </Grid>
            </Stack>
        </LoadingArea>
    )
}
export default SubjectsGrid
